import * as React from 'react';
import * as styles from './ActionButtons.css';
import { PublishButtonContainer } from '../PublishButton';
import { SaveDraftButtonContainer } from '../SaveDraftButton';

interface IProps {
  withPublishBtn: boolean;
}

export const ActionButtons = ({ withPublishBtn }: IProps) => {
  return (
    <>
      {withPublishBtn && (
        <div className={styles['button_wrapper']}>
          <PublishButtonContainer />
        </div>
      )}

      <div className={styles['button_wrapper']}>
        <SaveDraftButtonContainer />
      </div>
    </>
  );
};
